import { render, staticRenderFns } from "./CreateAutomation.vue?vue&type=template&id=e5c63bb8&scoped=true&"
import script from "./CreateAutomation.vue?vue&type=script&lang=js&"
export * from "./CreateAutomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c63bb8",
  null
  
)

export default component.exports